/**
 * ScrollToTop - Scrolls to top on route changes
 *
 * React Router v6 doesn't scroll to top automatically.
 * This component ensures pages start at the top.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
